import { useCallback, useEffect, useState } from 'react';
import { fetchHomeStats } from '../api/homeStats';

export default function useHomeStats() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const { cards: nextCards } = await fetchHomeStats();
      setCards(nextCards);
      setError('');
    } catch (err) {
      setError(err?.message || 'Failed to load stats.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { cards, loading, error, reload: load };
}
